import { NavBullet } from "./Navigation";
import styled, { css } from "styled-components";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { navigationHistory } from "../../routes";

export const NavItem: any = styled.li`
  background: #f0f0f0;
  :hover {
    background: ${(p: any) => p.color}50;
    cursor: pointer;
  }
  border-radius: 12px;
  padding: 2px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  font-weight: 500;
  min-width: 215px;
  text-decoration: none;

  ${(p: any) =>
    p.current &&
    css`
      background: ${(p: any) => p.color}50;
    `}
`;

export default ({
  current = null,
  items,
  onHover = () => {},
  onLeave = () => {},
}: any) => {
  const { t } = useTranslation("navigation");
  return (
    <>
      {items.map((navItem: any, index: number) => {
        return (
          <NavItem
            current={current && current.name === navItem.name}
            onClick={() => navigationHistory.push("/games/" + navItem.name)}
            onMouseEnter={() => onHover(navItem)}
            onMouseLeave={() => onLeave(null)}
            key={navItem.name}
            color={navItem.color}
          >
            <NavBullet color={navItem.color}>{index + 1}</NavBullet>
            {t("games." + navItem.name)}
          </NavItem>
        );
      })}
    </>
  );
};
